import { render, staticRenderFns } from "./ScatterAxisInfo.vue?vue&type=template&id=690ddee0&scoped=true&"
import script from "./ScatterAxisInfo.vue?vue&type=script&lang=js&"
export * from "./ScatterAxisInfo.vue?vue&type=script&lang=js&"
import style0 from "./ScatterAxisInfo.vue?vue&type=style&index=0&id=690ddee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ddee0",
  null
  
)

export default component.exports